import { render, staticRenderFns } from "./DataTableSales.vue?vue&type=template&id=22fa10bb&scoped=true"
import script from "./DataTableSales.vue?vue&type=script&lang=js"
export * from "./DataTableSales.vue?vue&type=script&lang=js"
import style0 from "./DataTableSales.vue?vue&type=style&index=0&id=22fa10bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa10bb",
  null
  
)

export default component.exports